export class AbstractService {
    /**
     * constructor
     * @param client
     */
    constructor(client) {
        /**
         * Instance of the Client class.
         */
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.client = client;
    }
}
//# sourceMappingURL=AbstractService.js.map